export const getAllDeliveryPostCodesData = ({ state }) =>
  state.deliveryPostCodes.deliveryPostCodesData;

export const getSelectedPostCodeData = ({ state }) => state.deliveryPostCodes.selectedPostCode;
